import type { StepProps } from '../../OBWWizard';

// Phase 5c.5 (ADR-030 D3) — partner-apply Welcome step.
// Programme intro + eligibility summary + "Get started" CTA.

export function PartnerWelcomeStep({ onNext }: StepProps) {
  return (
    <div className="obw-step-content">
      <h2 className="obw-title">Become a Nexanomics Partner</h2>
      <p className="obw-subtitle">
        Join the Nexanomics Partner Programme — refer subscribers, earn ongoing commission, and
        get a white-labelled reseller portal for your own clients.
      </p>

      <ul className="obw-steps-preview" aria-label="What you'll do">
        <li>
          <span className="obw-step-num" aria-hidden="true">1</span>
          <span>
            <strong style={{ color: 'var(--text)' }}>Accept the partner terms</strong><br />
            <span style={{ color: 'var(--text-dim)', fontSize: '14px' }}>
              Standard partner T&amp;Cs — commission schedule, brand usage, support obligations.
            </span>
          </span>
        </li>
        <li>
          <span className="obw-step-num" aria-hidden="true">2</span>
          <span>
            <strong style={{ color: 'var(--text)' }}>Confirm your details</strong><br />
            <span style={{ color: 'var(--text-dim)', fontSize: '14px' }}>
              We pre-fill from your subscriber account — just confirm or correct.
            </span>
          </span>
        </li>
        <li>
          <span className="obw-step-num" aria-hidden="true">3</span>
          <span>
            <strong style={{ color: 'var(--text)' }}>Tell us about your practice</strong><br />
            <span style={{ color: 'var(--text-dim)', fontSize: '14px' }}>
              Business registration and a short description of who you serve.
            </span>
          </span>
        </li>
        <li>
          <span className="obw-step-num" aria-hidden="true">4</span>
          <span>
            <strong style={{ color: 'var(--text)' }}>Submit your application</strong><br />
            <span style={{ color: 'var(--text-dim)', fontSize: '14px' }}>
              Our suitability check reviews your application and responds within a business day.
            </span>
          </span>
        </li>
      </ul>

      <div className="obw-info-box">
        <p>
          <strong>Programme eligibility</strong>
        </p>
        <p>
          The partner programme is open to active Nexanomics subscribers operating in Australia,
          New Zealand, or the United States. Subscribers with multiple domains, an active snippet,
          and clean payment history typically see the strongest fit signal.
        </p>
      </div>

      <div className="portal-wizard-nav">
        <button type="button" className="obw-btn-primary" onClick={() => onNext({})}>
          Get started →
        </button>
      </div>
    </div>
  );
}
